/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Cons_4Inputs */

const en_pc_rv_cons_4 = /** @type {(inputs: Pc_Rv_Cons_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High memory use on very large documents`)
};

const zh_pc_rv_cons_4 = /** @type {(inputs: Pc_Rv_Cons_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超大文档内存占用较高`)
};

/**
* | output |
* | --- |
* | "High memory use on very large documents" |
*
* @param {Pc_Rv_Cons_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_cons_4 = /** @type {((inputs?: Pc_Rv_Cons_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Cons_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_cons_4(inputs)
	return zh_pc_rv_cons_4(inputs)
});
export { pc_rv_cons_4 as "pc.rv.cons.4" }